import { createContext, useContext, useState } from "react";

const TripCtx = createContext({ trip: {}, setTrip: () => {} });

export function TripProvider({ children }) {
  const [trip, setTrip] = useState({});
  return <TripCtx.Provider value={{ trip, setTrip }}>{children}</TripCtx.Provider>;
}

export const useTrip = () => useContext(TripCtx);
